import { render, staticRenderFns } from "./InputCheckbox.vue?vue&type=template&id=00e56cad"
import script from "./InputCheckbox.vue?vue&type=script&lang=ts"
export * from "./InputCheckbox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports